module.exports = __webpack_public_path__ + "img/s00144.ecb89fc6.png";